import React, { useEffect, useState } from 'react';
// The KamoUniverse site has no /product or /features: its business operating system page and its
// product line are what the kamocrm.com site's pages of those names described.
const VARIANTS = {
    home: {
        label: 'Powered by KamoUniverse',
        href: 'https://www.kamouniverse.com/',
        ariaLabel: 'KamoUniverse — the all-in-one business operating system'
    },
    product: {
        label: 'Built on KamoUniverse',
        href: 'https://www.kamouniverse.com/business',
        ariaLabel: 'Built on the KamoUniverse business operating system'
    },
    features: {
        label: 'Running on KamoUniverse',
        href: 'https://www.kamouniverse.com/products',
        ariaLabel: 'Running on KamoUniverse — unified CRM, communications, and SI'
    }
};
/**
 * A subtle branding backlink that sits in the corner of the page. Intentionally low-contrast and
 * small so it does not interfere with white-label client branding, while still being a crawlable
 * dofollow link back to kamouniverse.com for SEO authority building.
 */
export default function PoweredByKamo({ variant = 'home', leftAligned = false }) {
    const { label, href, ariaLabel } = VARIANTS[variant];
    const [isNarrow, setIsNarrow] = useState(false);
    const [hover, setHover] = useState(false);
    const [focused, setFocused] = useState(false);
    useEffect(() => {
        const mq = window.matchMedia('(max-width: 480px)');
        const apply = () => setIsNarrow(mq.matches);
        apply();
        mq.addEventListener?.('change', apply);
        return () => mq.removeEventListener?.('change', apply);
    }, []);
    if (isNarrow) {
        return null;
    }
    const active = hover || focused;
    const style = {
        position: 'fixed',
        [leftAligned ? 'left' : 'right']: 16,
        bottom: 16,
        zIndex: 50,
        display: 'inline-flex',
        alignItems: 'center',
        gap: 4,
        padding: '6px 10px',
        borderRadius: 6,
        fontSize: 12,
        fontWeight: 500,
        lineHeight: 1,
        letterSpacing: '0.01em',
        fontFamily: 'system-ui, -apple-system, "Segoe UI", sans-serif',
        color: '#ffffff',
        background: active
            ? 'var(--color-primary, #6b8e3a)'
            : 'var(--color-secondary, #2a3d1e)',
        textDecoration: 'none',
        transition: 'background 180ms ease, box-shadow 180ms ease',
        boxShadow: active
            ? '0 4px 12px rgba(0, 0, 0, 0.18)'
            : '0 2px 6px rgba(0, 0, 0, 0.12)',
        outline: focused ? '2px solid #ffffff' : 'none',
        outlineOffset: 2,
        pointerEvents: 'auto',
        whiteSpace: 'nowrap'
    };
    return (React.createElement("a", { "aria-label": ariaLabel, href: href, onBlur: () => setFocused(false), onFocus: () => setFocused(true), onMouseEnter: () => setHover(true), onMouseLeave: () => setHover(false), rel: 'noopener', style: style },
        React.createElement("span", null, label),
        React.createElement("span", { "aria-hidden": 'true', style: {
                display: 'inline-block',
                opacity: active ? 1 : 0,
                transform: active ? 'translate(0, 0)' : 'translate(-2px, 2px)',
                transition: 'opacity 180ms ease, transform 180ms ease',
                fontSize: 10
            } }, "\u2197")));
}
